module.exports = __webpack_public_path__ + "img/btw2.6d136ca3.jpg";